import "../Tweets.css";

//react
import { useEffect, useState } from "react";

//components
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//antd
import { Typography } from "antd";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";

//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

const { Title } = Typography;

export default function Media({ selectedCountry, countryName, countries, countryOptions, setImg1, setImg2 }) {
    //language
    const { language } = useCurrentLanguage();

    //useState - data
    const [data, setData] = useState([]);

    //useState - data2
    const [data2, setData2] = useState([]);

    //useState - imgs
    // const [imgUrl1, setImgUrl1] = useState("");
    const [imgUrl2, setImgUrl2] = useState("");

    //isLac
    const isLac = selectedCountry === 'LAC'

    //useEffect
    useEffect(() => {
        if(selectedCountry !== '' && countries.length > 0) processData(["LAC"])
            console.log(data)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCountry, countries])

    //useEffect - imgs
    useEffect(() => {
        // setImg1(imgUrl1)
        setImg2(imgUrl2)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ imgUrl2])

    //process data
    const processData = async (selectedCountries) => {
        let df1 = await getCsvData(`/data/media/volume_shares.csv`);
        let df_lac = await getCsvData(`/data/media/volume_shares.csv`);
        let df_countries = await getCsvData(`/data/media/volume_shares.csv`);
    
        // Remove the last item in all datasets
        [df1, df_lac, df_countries].forEach(df => df.pop());
    
        // Filter country data if a specific country is selected
        if (selectedCountry !== 'LAC') {
            df1 = df1.filter(row => row.country === selectedCountry);
        }
    
        // Aggregate and average volume for LAC
        let tempDf1 = {};
        df_lac.forEach((e) => {
            if (!tempDf1[e.date]) {
                tempDf1[e.date] = { date: e.date, volume: 0, count: 0 };
            }
            tempDf1[e.date].volume += parseFloat(e.volume) || 0;
            tempDf1[e.date].count++;
        });
        df_lac = Object.values(tempDf1).map(entry => ({
            date: entry.date,
            volume: entry.volume / entry.count,
        }));
    
        // Prepare data for output
        let dates = [];
        let values = [];
        let values_lac = [];
        let values_countries = []; // Store data for selected countries
    
        if (selectedCountry === 'LAC') {
            df1 = df_lac;
    
            // Process data for each selected country beyond index 0
            selectedCountries.slice(1).forEach((code, index) => {
                let countryData = df_countries.filter(row => row.country === code);
                let countryValues = countryData.map(e => parseFloat(e.volume));
                values_countries[index] = countryValues;
            });
        }
    
        // Update dates and values for the primary dataset
        df1.forEach(row => {
            dates.push(formatTrimesterLabel(row.date, language));
            values.push(parseFloat(row.volume));
        });
    
        if (selectedCountry !== 'LAC') {
            df_lac.forEach(e => values_lac.push(parseFloat(e.volume)));
        }
    
        // Combine arrays for output
        let combinedArray = [dates, values];
        let combinedArray2 = [dates, values];
    
        if (selectedCountry !== 'LAC') {
            combinedArray2.push(values_lac);
        } else {
            // Add selected countries' data to combinedArray2
            values_countries.forEach(countryValues => {
                combinedArray2.push(countryValues);
            });
        }
    
        console.log("combinedArray2: ", combinedArray2);
    
        // Prepare series names
        let seriesName = [];
        let lac = language === 'es' ? "ALC" : "LAC";
    
        if (selectedCountry !== 'LAC') {
            seriesName = [countryName, lac];
        } else {
            seriesName = [lac];
            selectedCountries.slice(1).forEach(code => {
                let countryOption = countryOptions.find(e => e.code === code);
                if (countryOption) {
                    seriesName.push(language === 'es' ? countryOption.country_text : countryOption.country_text_en);
                }
            });
        }
    
        // Construct the data objects
        let temp = [
            {
                id: "q2",
                data: combinedArray,
                rotate: false,
                graphType: "bar",
                hasOptions: false,
                isPercentage: true,
                barLegend: language === 'es' ? "Porcentaje" : "Percentage",
                updateTotrimester: false,
            },
        ];
    
        let temp2 = [
            {
                id: "q2",
                data: combinedArray2,
                rotate: false,
                graphType: "line",
                hasOptions: false,
                isPercentage: true,
                barLegend: language === 'es' ? "Porcentaje" : "Percentage",
                updateTotrimester: false,
                seriesName: seriesName,
                hasCountries: selectedCountry === 'LAC',
                countryOptions: countries,
                selectedCountries: selectedCountries,
                useColors: false,
                description: TEXT['indicadores']['media1'][language]
            },
        ];
    
        console.log("temp2: ", temp2);
    
        setData(temp);
        setData2(temp2);
    };

    //handle countries change
    const handleCountriesChange = (countries) => {
        processData(countries)
    }


    return (
        <div className={`surveys-page-content ${!isLac ? "prensa-small-section-container" : ""}`}>
            <div className="surveys-page-graphs">
                <div className="survey-page-full-surveys">
                    <div className={`full-screen ${isLac ? "prensa-chart-container" : ""}`}>
                        <div className="prensa-chart-info-container">
                            <div className={`data-page-section-title prensa-chart-title text-left ${isLac ? "" : "mb-6"}`}>
                                {TEXT["volume"][language]}
                            </div>
                            {isLac && (
                                <>
                                    <Title level={2} style={{ color: "var(--blue-primary)", textAlign: "left" }}>
                                        {TEXT["volume"]["title"][language]}
                                    </Title>
                                    <div className="prensa-text-container">
                                        <p>{TEXT['volume']['description'][language]}</p>
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <TweetGraph data={data2} title={TEXT['volume']['graph1']['title'][language] + " " + countryName} setImgUrl={setImgUrl2} onCountriesChange={handleCountriesChange}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
